import { useEarmold } from "../hooks/earmolds.hooks";

const EarmoldTitle = ({
	earmold,
}: {
	earmold: string | number | undefined;
}) => {
	const { data: instance } = useEarmold(earmold);

	if (!instance) {
		return null;
	}
	return <>{instance?.label}</>;
};

export default EarmoldTitle;
